/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Onedata_Execute_LabelInputs */



/**
* | output |
* | --- |
* | "SQL to run as one transaction ({count} statements)" |
*
* @param {Chat_Onedata_Execute_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_onedata_execute_label = /** @type {((inputs: Chat_Onedata_Execute_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Onedata_Execute_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`SQL, das als eine Transaktion ausgeführt wird (${i?.count} Anweisungen)`)
	return /** @type {LocalizedString} */ (`SQL to run as one transaction (${i?.count} statements)`)
});